export default {
  actions: {
    reset_messages(context) {
      context.state.messages = [];
    },
  },
  getters: {
    messages: (state) => state.messages,
  },
  mutations: {
    push_message(state, payload) {
      const lState = state;
      const messageObj = {
        title: payload.title,
        body: payload.body,
        type: payload.type,
      };
      lState.messages.push(messageObj);
    },
    pop_message: (state) => state.messages.pop(),
  },
  state: {
    messages: [],
  },
};
